import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { InfoCircleFill, ThreeDots, X } from 'react-bootstrap-icons';
import AppBackButton from '../common/AppBackButton';
import './Dashboard.css';

const mockReviewCards = [
  {
    id: 1,
    title: "Recruiter's Title",
    copy: "Didn't select you after an interview and is ready to provide feedback on your profile.",
  },
  {
    id: 2,
    title: "Recruiter's Title",
    copy: "Didn't select you after an interview and is ready to provide feedback on your profile.",
  },
  {
    id: 3,
    title: "Recruiter's Title",
    copy: "Didn't select you after an interview and is ready to provide feedback on your profile.",
  },
];

const RateMeComingSoon: React.FC = () => {
  const [isInfoCardVisible, setIsInfoCardVisible] = useState(true);

  return (
    <div className="rate-me-page">
      <main className="rate-me-main">
        <AppBackButton />
        <section className="rate-me-hero-card">
          <div className="rate-me-hero-copy">
            <div className="rate-me-kicker">New Feature Announced! 🎉</div>
            <h1 className="rate-me-title">Rate Me Beta Coming Soon</h1>
            <p className="rate-me-subtitle">
              Get feedback on your profile to skip screening faster.
            </p>
            <p className="rate-me-body">
              Request feedback from recruiters who recently interviewed you but didn&apos;t select
              you. Make improvements and boost your hiring chances.
            </p>
            <Button variant="success" className="rate-me-learn-btn" disabled>
              Learn More
            </Button>
          </div>
          <div className="rate-me-hero-art" aria-hidden="true">
            <div className="rate-me-hero-cloud" />
            <div className="rate-me-hero-illustration">
              <div className="rate-me-person-head" />
              <div className="rate-me-person-body" />
              <div className="rate-me-rating-card">★★★★★</div>
            </div>
          </div>
        </section>

        <div className="rate-me-grid">
          <div className="rate-me-left-column">
            <section className="rate-me-preview-card">
              <div className="rate-me-preview-header">
                <h2>Rate Me</h2>
                <span className="rate-me-badge">Beta Coming Soon</span>
                <InfoCircleFill className="rate-me-info-icon" />
                <button type="button" className="rate-me-menu-btn" aria-label="More options">
                  <ThreeDots />
                </button>
              </div>
              <div className="rate-me-preview-list">
                {mockReviewCards.map((card) => (
                  <div key={card.id} className="rate-me-mini-card">
                    <div className="rate-me-mini-avatar" />
                    <div className="rate-me-mini-stars">★★★★★</div>
                    <div className="rate-me-mini-title">{card.title}</div>
                    <div className="rate-me-mini-copy">{card.copy}</div>
                  </div>
                ))}
              </div>
              <div className="rate-me-callout">
                Request feedback from recruiters you recently interviewed with but didn&apos;t
                select you. <strong>Coming soon!</strong>
              </div>
            </section>

            <section className="rate-me-bottom-card">
              <div className="rate-me-bottom-icon">📈</div>
              <p>
                Request feedback from recruiters you recently interviewed with but didn&apos;t
                select you. Unsuccessful interviews can still contribute to future selection,
                empowering recruiters to rate you and provide feedback that you can display at your
                discretion.
                <strong> Coming soon!</strong>
              </p>
            </section>
          </div>

          {isInfoCardVisible ? (
            <section className="rate-me-modal-preview">
              <div className="rate-me-modal-head">
                <span>Rate Me (Beta Coming Soon)</span>
                <button
                  type="button"
                  className="rate-me-close-btn"
                  aria-label="Dismiss rate me information card"
                  onClick={() => setIsInfoCardVisible(false)}
                >
                  <X />
                </button>
              </div>
              <div className="rate-me-modal-body">
                <ul>
                  <li>
                    Request anonymous feedback on your profile from recruiters you recently
                    interviewed with but didn&apos;t select you.
                  </li>
                  <li>
                    Receive constructive advice on how to strengthen your answers and portfolio.
                  </li>
                  <li>
                    Get personalized tips on how to make a strong impression in future recruiter
                    screenings.
                  </li>
                </ul>
                <p>
                  Even unsuccessful interviews can contribute to your future selection. Document
                  positive feedback and ratings, showing new recruiters the caliber of recruiters
                  who interviewed you and the positives they noted.
                </p>
              </div>
              <div className="rate-me-modal-footer">
                <Button variant="success" onClick={() => setIsInfoCardVisible(false)}>
                  Got it!
                </Button>
              </div>
            </section>
          ) : null}
        </div>
      </main>
    </div>
  );
};

export default RateMeComingSoon;
